export default "__VITE_ASSET__CFrpdnGl__"